module.exports = __webpack_public_path__ + "static/media/comments.9dfc7e2f.svg";